import { render, staticRenderFns } from "./s-advice.vue?vue&type=template&id=6649ea1b&scoped=true&"
import script from "./s-advice.vue?vue&type=script&lang=js&"
export * from "./s-advice.vue?vue&type=script&lang=js&"
import style0 from "./s-advice.vue?vue&type=style&index=0&id=6649ea1b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6649ea1b",
  null
  
)

export default component.exports